import userAPI from "../../API/endpoints/user";
import { sliceActions } from "../user-slice";

export const fetch = () => {
  return async (dispatch) => {
    try {
      const response = await userAPI.get();
      dispatch(sliceActions.setUser(response.data));
    } catch (error) {
      dispatch(sliceActions.setUser(undefined));
      console.log(error);
    }
  };
};
